const sirenValidator = (siren) => {
  if (!siren || !siren.length) {
    return true;
  }
  if (siren.length !== 9 || isNaN(siren)) {
    return false;
  } else {
    let somme = 0;
    let tmp;
    for (let cpt = 0; cpt < siren.length; cpt++) {
      if (cpt % 2 === 1) {
        tmp = siren.charAt(cpt) * 2;
        if (tmp > 9) {
          tmp -= 9;
        }
      } else {
        tmp = siren.charAt(cpt);
      }
      somme += parseInt(tmp, 10);
    }
    if (somme % 10 !== 0) {
      return false;
    }
  }
  return true;
};
export {
  sirenValidator
};
//# sourceMappingURL=siren.es.js.map
